// @utilities
const { APIGet } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');

// @constants
const actionTypes = require('../raConstants/actionTypes');

const getCGDAccountNumberSuccess = data => ({
    type: actionTypes.RA_GET_ACCOUNT_DETAILS_SUCCESS,
    payload: { data },
});

const getCGDAccountNumberFailure = error => ({
    type: actionTypes.RA_GET_ACCOUNT_DETAILS_FAILURE,
    payload: { error },
});

const getCGDAccountNumberInProgress = () => ({
    type: actionTypes.RA_GET_ACCOUNT_DETAILS_REQUEST,
});

const getCGDAccountNumber = portfolioId => dispatch => {
    const params = {
        portfolioId: portfolioId,
    };
    dispatch(getCGDAccountNumberInProgress());
    return APIGet(dispatch, apiURLBuilder.getURL('raCGDDetails', params))
        .then(response => {
            dispatch(getCGDAccountNumberSuccess(response));
        })
        .catch(error => {
            dispatch(getCGDAccountNumberFailure(error));
        });
};

const getPortfolioHistoryInProgress = () => ({
    type: actionTypes.RA_PORTFOLIO_HISTORY_REQUEST,
});

const getPortfolioHistoryRequestSuccess = data => ({
    type: actionTypes.RA_PORTFOLIO_HISTORY_REQUEST_SUCCESS,
    payload: { data },
});

const getPortfolioHistoryRequestFailure = error => ({
    type: actionTypes.RA_PORTFOLIO_HISTORY_REQUEST_FAILURE,
    payload: { error },
});

const getPortfolioHistory = portfolioId => dispatch => {
    const params = {
        portfolioId: portfolioId,
    };
    dispatch(getPortfolioHistoryInProgress());
    return APIGet(dispatch, apiURLBuilder.getURL('raPortfolioHistory', params))
        .then(response => {
            dispatch(getPortfolioHistoryRequestSuccess(response));
        })
        .catch(error => {
            dispatch(getPortfolioHistoryRequestFailure(error));
        });
};

module.exports = {
    getCGDAccountNumber,
    getPortfolioHistory,
};
